import { API_URL } from '../config';

// Add debug log
console.log('API_URL:', process.env.REACT_APP_API_URL);

export const saveUserToDb = async (user) => {
    try {
        const token = await user.getIdToken();
        const response = await fetch(`${API_URL}/users`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                uid: user.uid,
                email: user.email,
                displayName: user.displayName,
                photoURL: user.photoURL,
                createdAt: new Date().toISOString(),
                lastLoginAt: new Date().toISOString(),
                profileCompleted: false
            })
        });

        if (!response.ok) {
            throw new Error('Failed to save user to database');
        }

        const data = await response.json();

        // Return true if this is a new user (profile not completed)
        return !data.profileCompleted;

    } catch (error) {
        console.error('Error saving user to database:', error);
        throw error;
    }
};

// Fixed getUserProfile to accept the user object as parameter
export const getUserProfile = async (userId, user) => {
    try {
        const token = await user.getIdToken();
        const response = await fetch(`${API_URL}/users/${userId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error('Failed to fetch user profile');
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching user profile:', error);
        throw error;
    }
}; 